import { revokeLicenseBody } from '@planuze/admin-contracts';
import { toast } from '@planuze/ui';
import { useUsersContent } from '../../../content/sections/users.js';
import { useRevokeLicense } from '../../../hooks/use-users.js';
import { ReasonDialog } from '../../reason-dialog.js';
import { userErrorMessage } from '../user-error.js';

interface Props {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly userId: string;
  readonly packId: string;
}

export function RevokeLicenseModal({ open, onClose, userId, packId }: Props) {
  const copy = useUsersContent();
  const revoke = useRevokeLicense(userId);
  const confirm = (reason: string): void => {
    revoke.mutate(
      { packId, reason },
      {
        onSuccess: () => {
          toast.success(copy.revokeLicenseModal.success(packId));
          onClose();
        },
        onError: (err) => {
          toast.error(userErrorMessage(err, copy.errors));
        },
      },
    );
  };
  return (
    <ReasonDialog
      open={open}
      onClose={onClose}
      title={copy.revokeLicenseModal.title(packId)}
      description={copy.revokeLicenseModal.description}
      confirmLabel={copy.revokeLicenseModal.confirmLabel}
      reasonLabel={copy.revokeLicenseModal.reasonLabel}
      destructive
      pending={revoke.isPending}
      validate={(reason) => revokeLicenseBody.safeParse({ reason }).success}
      onConfirm={confirm}
    />
  );
}
